import { useTranslation } from 'react-i18next';

function trackAppDownload() {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'app_download', {
      event_category: 'engagement',
      event_label: 'Mac App Store',
      app_id: '6759054080',
    });
  }
}

export default function AppStoreBadges() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row gap-2 items-center justify-center">
      <a
        href="https://apps.apple.com/app/id6759054080?mt=12"
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-block hover:scale-105 transition-transform duration-200"
        data-fast-goal="mac_download"
        onClick={trackAppDownload}
      >
        <img 
          src="/app-store-badge.svg" 
          alt={t('appStore.downloadButton')} 
          style={{ height: '60px', width: 'auto' }}
        />
      </a>
    </div>
  );
}
